var React = require('react');

function FDLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Color_Fill_1","data-name":"Color Fill 1","className":"logo","d":"M102,1h3c0.273,12.455,2.188,32.015-2,41L0,101V60Zm70,40c5.452,6.139,2,72.617,2,87q-0.5,39.5-1,79c-8.661,39.34-46.093,80.832-100,70C23.19,266.991-21.213,210.459,9,151c11.473-22.578,69.72-63.1,96-70,0.332,9.8,3.141,34.395-2,40-20.233,19.1-54.44,22.1-65,51-15.421,42.2,25.121,83.326,67,68,41.91-15.337,34.01-71.244,34-128,0-12.325-4.573-44.455,2-52Z"}));
}

FDLogo.defaultProps = {"width":"174","height":"278","viewBox":"0 0 174 278"};

module.exports = FDLogo;

FDLogo.default = FDLogo;
